export default __webpack_public_path__ + "static/media/barn.97725ff4.svg";